<template>
  <div id="mask" v-if="show" @click="close()" ref="" >
    <div class="award" v-on:click.stop>
      <div class="title">{{title}}</div>
      <div class="img-container" v-if="award.reward_image">
        <img :src="award.reward_image" alt="">
      </div>
      <div class="desc">{{award.reward_msg}}</div>
      <div class="close-btn"  @click="close()"></div>
      <div class="sign-btn" v-if="gameLink"><a :href="gameLink">进入游戏</a></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'toast',
  props: {
    title: '',
    award: {},
    show: false,
    gameLink: '',
  },

  methods: {
    close() {
      this.$emit('update:show', false)
    },
  },
}
</script>

<style lang="scss" src="./toast.scss" scoped></style>
